import React from 'react'
import { Form, Button, OverlayTrigger, Tooltip } from 'react-bootstrap'

const AmountInput = ({
    amount,
    useMaxAmount,
    selectedToken,
    onAmountChange,
    onMaxClick,
    getAmountError,
    isShielding
}) => {
    return (
        <Form.Group className="mb-4">
            <Form.Label className="fw-semibold flex items-center gap-2" style={{ color: 'var(--text-primary)' }}>
                <>
                {isShielding ? "Add Shield Amount" : "Send Amount"}
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="coin-image-tooltip">{isShielding ?  "You can shield tokens up to your public pool balance of your 'Token to Shield'" : "You can send token less than equal to your token balance" }</Tooltip>}
              >
                <svg width="16px" height="16px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M8 16A8 8 0 108 0a8 8 0 000 16zm0-9a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 018 7zm0-3a1 1 0 000 2h.007a1 1 0 000-2H8z" clip-rule="evenodd"/></svg>
              </OverlayTrigger>
              </>
              <p className="text-muted small mb-0">
                {amount ? `~$${(amount * selectedToken?.price?.price).toFixed(2)}` : 'Enter an amount to see its USD value'}
              </p>
            </Form.Label>

            <div className="input-group">
                <Form.Control
                    type="number"
                    placeholder="0.00"
                    value={amount}
                    onChange={(e) => onAmountChange(e.target.value)}
                    onWheel={(e) => e.target.blur()}
                    className="form-input form-control m-0"
                />

                <Button
                    variant={useMaxAmount ? 'primary' : 'outline-primary'}
                    onClick={onMaxClick}
                    className="fw-semibold px-3 w-auto"
                    style={{
                        borderColor: 'var(--accent-color)',
                        color: useMaxAmount ? '#ffffff' : 'var(--accent-color)',
                        backgroundColor: useMaxAmount ? 'var(--accent-color)' : 'transparent'
                    }}
                >
                    MAX
                </Button>
            </div>

            {getAmountError() && (
                <Form.Text className="text-danger small mt-1 d-block">
                    {getAmountError()}
                </Form.Text>
            )}

            {useMaxAmount && !getAmountError() && (
                <Form.Text className="small mt-1 d-block">
                     Using all available tokens ({selectedToken?.balance} {selectedToken?.symbol}) (~${(selectedToken?.balance * selectedToken?.price?.price).toFixed(2)})
                </Form.Text>
            )}
        </Form.Group>
    )
}

export default AmountInput
